function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import "jquery.cookie";
import * as React from "react";
import * as ReactDOM from "react-dom";
import SwipeableViews from 'react-swipeable-views';
import Pagination from '../commons/Pagination';
import IntlMessage from '../commons/Intl';
import { IntlProvider, FormattedMessage } from 'react-intl';
import { locales } from '../commons/Intl';
import { Action, SphereCast, SphereCastView } from "../commons/IntlMessages";
var defaultLanguage = 'ja';
var intl = new IntlMessage(defaultLanguage);
var language = window.navigator.language.substring(0, 2) === 'ja' ? 'ja' : 'en';
intl.setLanguage(language);
var messages = locales[language];
var styles = {
  slide: {
    padding: 15,
    minHeight: 100,
    color: '#fff'
  },
  slide1: {},
  slide2: {},
  slide3: {},
  slide4: {},
  slide5: {},
  slide6: {},
  slide7: {}
};
/**
 * メインコンポーネント
 */

var MainComponent = /*#__PURE__*/function (_React$Component) {
  _inherits(MainComponent, _React$Component);

  var _super = _createSuper(MainComponent);

  /**
   * フィールド変数の初期化を行います。
   *
   * @param props プロップス
   */
  function MainComponent(props) {
    var _this;

    _classCallCheck(this, MainComponent);

    _this = _super.call(this, props);
    _this.state = {
      ActiveIndex: 0,
      Messages: []
    };
    return _this;
  }
  /**
   * SphereCastStreamingモーダルを表示のみで起動します。
   */


  _createClass(MainComponent, [{
    key: "copyLink",
    value: function copyLink() {
      this.props.common.copyToClipboard(decodeURIComponent(atob(this.props.streamingUrl)));
      this.state.Messages.push(intl.format(SphereCastView.CopyPublishLinkMessage));
      this.setState({
        Messages: this.state.Messages
      });
    }
    /**
     * ページ番号変更
     * @param pageNumber ページ番号
     */

  }, {
    key: "onHandleIndexChange",
    value: function onHandleIndexChange(index) {
      this.setState({
        ActiveIndex: index,
        Messages: index == 0 ? this.state.Messages : []
      });
    }
    /**
     * ComponentがDOMツリーに追加された状態で呼ばれるDOMに関わる初期化処理
     */

  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.common.bind();
    }
    /**
     * ComponentがDOMツリーから削除された状態で呼ばれるDOMに関わる初期化処理
     */

  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {}
    /**
     * レンダラー
     */

  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(IntlProvider, {
        locale: language,
        messages: messages
      }, /*#__PURE__*/React.createElement("div", {
        className: "content-container"
      }, /*#__PURE__*/React.createElement("div", {
        id: "overlay"
      }, /*#__PURE__*/React.createElement("div", {
        className: "cv-spinner"
      }, /*#__PURE__*/React.createElement("span", {
        className: "spinner"
      }))), /*#__PURE__*/React.createElement("div", {
        className: "content-header"
      }, /*#__PURE__*/React.createElement("div", {
        className: "container"
      }, this.state.Messages.length > 0 && /*#__PURE__*/React.createElement("div", {
        className: "validation-summary-messages"
      }, /*#__PURE__*/React.createElement("ul", null, this.state.Messages.map(function (x, i) {
        return /*#__PURE__*/React.createElement("li", {
          key: i
        }, x);
      }))))), /*#__PURE__*/React.createElement("div", {
        id: "content-main",
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-12 title__frame"
      }, /*#__PURE__*/React.createElement("div", {
        className: "title"
      }, /*#__PURE__*/React.createElement("img", {
        className: "mainIcon",
        width: "40",
        height: "42",
        src: "/assets/img/Icon_360streaming_grey.svg"
      }), /*#__PURE__*/React.createElement("h1", null, intl.format(SphereCast.Title)))), /*#__PURE__*/React.createElement("div", {
        className: "col-12 mx-auto center"
      }, /*#__PURE__*/React.createElement(SwipeableViews, {
        enableMouseEvents: true,
        index: this.state.ActiveIndex,
        onChangeIndex: this.onHandleIndexChange.bind(this)
      }, /*#__PURE__*/React.createElement("div", {
        style: Object.assign({}, styles.slide, styles.slide1)
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-12 mx-auto center"
      }, this.props.deviceType == "Android" && /*#__PURE__*/React.createElement("label", {
        className: "tutorial__message"
      }, /*#__PURE__*/React.createElement(FormattedMessage, Object.assign({}, SphereCastView.TutorialMessage_01, {
        values: {
          app: /*#__PURE__*/React.createElement("a", {
            href: "https://play.google.com/store/apps/details?id=com.arashivision.insta360akiko&hl=ja&gl=US&pli=1",
            target: "_blank",
            className: "insta360__link"
          }, intl.format(SphereCastView.Insta360App))
        }
      }))), this.props.deviceType != "Android" && /*#__PURE__*/React.createElement("label", {
        className: "tutorial__message"
      }, /*#__PURE__*/React.createElement(FormattedMessage, Object.assign({}, SphereCastView.TutorialMessage_01, {
        values: {
          app: /*#__PURE__*/React.createElement("a", {
            href: "https://apps.apple.com/jp/app/insta360/id1491299654",
            target: "_blank",
            className: "insta360__link"
          }, intl.format(SphereCastView.Insta360App))
        }
      })))), /*#__PURE__*/React.createElement("div", {
        className: "col-12 mx-auto center"
      }, /*#__PURE__*/React.createElement("img", {
        className: "tutorial__image",
        src: "/assets/img/Image_360Streaming_Tutorial_01.png"
      }))), /*#__PURE__*/React.createElement("div", {
        style: Object.assign({}, styles.slide, styles.slide2)
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-12 mx-auto center"
      }, /*#__PURE__*/React.createElement("label", {
        className: "tutorial__message"
      }, intl.format(SphereCastView.TutorialMessage_02))), /*#__PURE__*/React.createElement("div", {
        className: "col-12 mx-auto center"
      }, /*#__PURE__*/React.createElement("img", {
        className: "tutorial__image",
        src: "/assets/img/Image_360Streaming_Tutorial_02.png"
      }))), /*#__PURE__*/React.createElement("div", {
        style: Object.assign({}, styles.slide, styles.slide3)
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-12 mx-auto center"
      }, /*#__PURE__*/React.createElement("label", {
        className: "tutorial__message"
      }, intl.format(SphereCastView.TutorialMessage_03))), /*#__PURE__*/React.createElement("div", {
        className: "col-12 mx-auto center"
      }, /*#__PURE__*/React.createElement("img", {
        className: "tutorial__image",
        src: "/assets/img/Image_360Streaming_Tutorial_03.png"
      }))), /*#__PURE__*/React.createElement("div", {
        style: Object.assign({}, styles.slide, styles.slide4)
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-12 mx-auto center"
      }, /*#__PURE__*/React.createElement("label", {
        className: "tutorial__message"
      }, intl.format(SphereCastView.TutorialMessage_04))), /*#__PURE__*/React.createElement("div", {
        className: "col-12 mx-auto center"
      }, /*#__PURE__*/React.createElement("img", {
        className: "tutorial__image",
        src: "/assets/img/Image_360Streaming_Tutorial_04.png"
      }))), /*#__PURE__*/React.createElement("div", {
        style: Object.assign({}, styles.slide, styles.slide5)
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-12 mx-auto center"
      }, /*#__PURE__*/React.createElement("label", {
        className: "tutorial__message"
      }, intl.format(SphereCastView.TutorialMessage_05))), /*#__PURE__*/React.createElement("div", {
        className: "col-12 mx-auto center"
      }, /*#__PURE__*/React.createElement("img", {
        className: "tutorial__image",
        src: "/assets/img/Image_360Streaming_Tutorial_05.png"
      }))), /*#__PURE__*/React.createElement("div", {
        style: Object.assign({}, styles.slide, styles.slide6)
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-12 mx-auto center"
      }, /*#__PURE__*/React.createElement("label", {
        className: "tutorial__message"
      }, intl.format(SphereCastView.TutorialMessage_06))), /*#__PURE__*/React.createElement("div", {
        className: "col-12 mx-auto center"
      }, /*#__PURE__*/React.createElement("img", {
        className: "tutorial__image",
        src: "/assets/img/Image_360Streaming_Tutorial_06.png"
      }))), /*#__PURE__*/React.createElement("div", {
        style: Object.assign({}, styles.slide, styles.slide7)
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-12 mx-auto center"
      }, /*#__PURE__*/React.createElement("label", {
        className: "notes__title"
      }, intl.format(SphereCastView.TutorialMessage_07_01)), /*#__PURE__*/React.createElement("label", {
        className: "notes__message"
      }, intl.format(SphereCastView.TutorialMessage_07_02)), /*#__PURE__*/React.createElement("label", {
        className: "notes__message"
      }, intl.format(SphereCastView.TutorialMessage_07_03)), /*#__PURE__*/React.createElement("label", {
        className: "notes__message"
      }, intl.format(SphereCastView.TutorialMessage_07_04)), /*#__PURE__*/React.createElement("label", {
        className: "notes__message"
      }, intl.format(SphereCastView.TutorialMessage_07_05)), /*#__PURE__*/React.createElement("label", {
        className: "notes__message"
      }, intl.format(SphereCastView.TutorialMessage_07_06)), /*#__PURE__*/React.createElement("label", {
        className: "notes__message"
      }, intl.format(SphereCastView.TutorialMessage_07_07))))), /*#__PURE__*/React.createElement(Pagination, {
        dots: 7,
        index: this.state.ActiveIndex,
        onChangeIndex: this.onHandleIndexChange
      })), /*#__PURE__*/React.createElement("div", {
        className: "col-12 mx-auto center"
      }, /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "btn btn-primary openCont",
        onClick: this.copyLink.bind(this),
        tabIndex: -1
      }, /*#__PURE__*/React.createElement("img", {
        className: "openCont__icon",
        src: "/assets/img/Icon_CopyLink_White.svg"
      }), /*#__PURE__*/React.createElement("div", {
        className: "openCont__name"
      }, intl.format(Action.CopyLink)))), /*#__PURE__*/React.createElement("div", {
        className: "main__footer"
      }, this.props.deviceType == "Android" && /*#__PURE__*/React.createElement("a", {
        href: "https://play.google.com/store/apps/details?id=com.arashivision.insta360akiko",
        target: "_blank"
      }, /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "btn btn-primary appCont",
        tabIndex: -1
      }, /*#__PURE__*/React.createElement("img", {
        className: "appCont__icon",
        src: "/assets/img/Icon_Open_Black.svg"
      }), /*#__PURE__*/React.createElement("div", {
        className: "appCont__name"
      }, intl.format(SphereCastView.OpenInsta360App)))), this.props.deviceType != "Android" && /*#__PURE__*/React.createElement("a", {
        href: "https://apps.apple.com/jp/app/insta360/id1491299654",
        target: "_blank"
      }, /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "btn btn-primary appCont",
        tabIndex: -1
      }, /*#__PURE__*/React.createElement("img", {
        className: "appCont__icon",
        src: "/assets/img/Icon_Open_Black.svg"
      }), /*#__PURE__*/React.createElement("div", {
        className: "appCont__name"
      }, intl.format(SphereCastView.OpenInsta360App))))))));
    }
  }]);

  return MainComponent;
}(React.Component);
/**
 * レンダラー
 *
 * @param el バインド対象
 * @param common 共通
 * @param deviceType デバイス種別
 * @param streamingUrl 配信URL
 * @param host ホスト
 */


export default function (el, common, deviceType, streamingUrl, host) {
  ReactDOM.render( /*#__PURE__*/React.createElement(MainComponent, {
    common: common,
    deviceType: deviceType,
    streamingUrl: streamingUrl,
    host: host
  }), el);
}